import React from "react";
import { useTranslation } from "react-i18next";

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  const renderTextWithLinks = (text) => {
    if (!text) return null;
    const regex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})|(\+65\s?\d{4}\s?\d{4})/g;
    const parts = text.split(regex);
    return parts.map((part, index) => {
      if (part === undefined || part === "") return null;
      
      const isEmail = part.includes("@");
      const isWhatsApp = part.startsWith("+65");
      
      if (isEmail) {
        return (
          <a key={index} href={`mailto:${part}`}>
            {part}
          </a>
        );
      }
      if (isWhatsApp) {
        const cleanNum = part.replace(/\s+/g, "");
        return (
          <a key={index} href={`https://wa.me/${cleanNum.replace("+", "")}`}>
            {part}
          </a>
        );
      }
      return part;
    });
  };

  const pageStyle = {
    maxWidth: "800px",
    margin: "20px auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.6",
    color: "#dfbd69",
    borderRadius: "10px",
    backgroundColor: "transparent",
  };
  const headingStyle = {
    color: "#dfbd69",
    textAlign: "center",
    marginBottom: "20px",
  };

  const sectionHeadingStyle = {
    color: "#dfbd69",
    fontSize: "1.2rem",
    margin: "15px 0",
  };

  const subSectionHeadingStyle = {
    color: "#dfbd69",
    fontSize: "1.05rem",
    margin: "10px 0 5px 0",
    fontWeight: "bold",
  };

  return (
    <div style={pageStyle}>
      <h1 style={headingStyle}>{t("privacyPage.title")}</h1>

      <h2 style={sectionHeadingStyle}>{t("privacyPage.preambleTitle")}</h2>
      <p>{t("privacyPage.preambleText")}</p>

      <h2 style={sectionHeadingStyle}>{t("privacyPage.collectTitle")}</h2>
      <p>{t("privacyPage.collectText1")}</p>
      <p>{t("privacyPage.collectText2")}</p>

      <h2 style={sectionHeadingStyle}>{t("privacyPage.profilingTitle")}</h2>
      <p>{t("privacyPage.profilingText")}</p>

      <h2 style={sectionHeadingStyle}>{t("privacyPage.deliveryAddressTitle")}</h2>
      <p>{t("privacyPage.deliveryAddressText")}</p>

      <h2 style={sectionHeadingStyle}>{t("privacyPage.fengShuiDataTitle")}</h2>
      <p>{t("privacyPage.fengShuiDataText")}</p>

      <h2 style={sectionHeadingStyle}>{t("privacyPage.usageTitle")}</h2>
      <p>{t("privacyPage.usageIntro")}</p>
      <ul>
        <li>{t("privacyPage.usageList1")}</li>
        <li>{t("privacyPage.usageList2")}</li>
        <li>{t("privacyPage.usageList3")}</li>
        <li>{t("privacyPage.usageList4")}</li>
        <li>{t("privacyPage.usageList5")}</li>
        <li>{t("privacyPage.usageList6")}</li>
      </ul>

      <h2 style={sectionHeadingStyle}>{t("privacyPage.protectionTitle")}</h2>
      <p>{t("privacyPage.protectionText1")}</p>
      <p>{t("privacyPage.protectionText2")}</p>

      <h2 style={sectionHeadingStyle}>{t("privacyPage.cookiesTitle")}</h2>
      <p>{t("privacyPage.cookiesText")}</p>

      <h2 style={sectionHeadingStyle}>{t("privacyPage.disclosureTitle")}</h2>
      <p>{t("privacyPage.disclosureText")}</p>

      <h2 style={sectionHeadingStyle}>{t("privacyPage.linksTitle")}</h2>
      <p>{t("privacyPage.linksText")}</p>

      <h2 style={sectionHeadingStyle}>{t("privacyPage.consentTitle")}</h2>
      <p>{renderTextWithLinks(t("privacyPage.consentText"))}</p>

      <h2 style={sectionHeadingStyle}>{t("privacyPage.changesTitle")}</h2>
      <p>{t("privacyPage.changesText")}</p>

      <h2 style={sectionHeadingStyle}>{t("privacyPage.contactTitle")}</h2>
      <p style={{ whiteSpace: "pre-line" }}>{renderTextWithLinks(t("privacyPage.contactText"))}</p>

      <h2 style={sectionHeadingStyle}>{t("privacyPage.permissionsTitle")}</h2>
      
      <h3 style={subSectionHeadingStyle}>{t("privacyPage.cameraTitle")}</h3>
      <p>{t("privacyPage.cameraIntro")}</p>
      <ul>
        <li>{t("privacyPage.cameraList1")}</li>
        <li>{t("privacyPage.cameraList2")}</li>
        <li>{t("privacyPage.cameraList3")}</li>
      </ul>
      <p>{t("privacyPage.cameraUsageIntro")}</p>
      <ul>
        <li>{t("privacyPage.cameraUsageList1")}</li>
        <li>{t("privacyPage.cameraUsageList2")}</li>
        <li>{t("privacyPage.cameraUsageList3")}</li>
        <li>{t("privacyPage.cameraUsageList4")}</li>
      </ul>

      <h3 style={subSectionHeadingStyle}>{t("privacyPage.micTitle")}</h3>
      <p>{t("privacyPage.micIntro")}</p>
      <ul>
        <li>{t("privacyPage.micList1")}</li>
        <li>{t("privacyPage.micList2")}</li>
      </ul>

      <h3 style={subSectionHeadingStyle}>{t("privacyPage.otherTitle")}</h3>
      <ul>
        <li>{t("privacyPage.otherList1")}</li>
        <li>{t("privacyPage.otherList2")}</li>
        <li>{t("privacyPage.otherList3")}</li>
        <li>{t("privacyPage.otherList4")}</li>
      </ul>

      <h2 style={sectionHeadingStyle}>{t("privacyPage.thirdPartyTitle")}</h2>

      <h3 style={subSectionHeadingStyle}>{t("privacyPage.streamingTitle")}</h3>
      <p>{t("privacyPage.streamingIntro")}</p>
      <ul>
        <li>{t("privacyPage.streamingList1")}</li>
        <li>{t("privacyPage.streamingList2")}</li>
        <li>{t("privacyPage.streamingList3")}</li>
        <li>{t("privacyPage.streamingList4")}</li>
        <li>{t("privacyPage.streamingList5")}</li>
        <li>{t("privacyPage.streamingList6")}</li>
      </ul>

      <h3 style={subSectionHeadingStyle}>{t("privacyPage.paymentTitle")}</h3>
      <p>{t("privacyPage.paymentIntro")}</p>
      <ul>
        <li>{t("privacyPage.paymentList1")}</li>
        <li>{t("privacyPage.paymentList2")}</li>
        <li>{t("privacyPage.paymentList3")}</li>
      </ul>

      <h3 style={subSectionHeadingStyle}>{t("privacyPage.pushTitle")}</h3>
      <p>{t("privacyPage.pushIntro")}</p>
      <ul>
        <li>{t("privacyPage.pushList1")}</li>
        <li>{t("privacyPage.pushList2")}</li>
        <li>{t("privacyPage.pushList3")}</li>
        <li>{t("privacyPage.pushList4")}</li>
      </ul>
      <p>{renderTextWithLinks(t("privacyPage.pushOutro"))}</p>

      <h2 style={sectionHeadingStyle}>{t("privacyPage.retentionTitle")}</h2>
      <h3 style={subSectionHeadingStyle}>{t("privacyPage.retentionSubTitle")}</h3>
      <ul>
        <li>{t("privacyPage.retentionList1")}</li>
        <li>{t("privacyPage.retentionList2")}</li>
        <li>{t("privacyPage.retentionList3")}</li>
        <li>{t("privacyPage.retentionList4")}</li>
        <li>{t("privacyPage.retentionList5")}</li>
        <li>{t("privacyPage.retentionList6")}</li>
      </ul>
      <p>{renderTextWithLinks(t("privacyPage.retentionOutro"))}</p>

      <h2 style={sectionHeadingStyle}>{t("privacyPage.under18Title")}</h2>
      <p>{t("privacyPage.under18Text")}</p>

      <h2 style={sectionHeadingStyle}>{t("privacyPage.rightsTitle")}</h2>
      <p>{t("privacyPage.rightsIntro")}</p>
      <ul>
        <li>{t("privacyPage.rightsList1")}</li>
        <li>{t("privacyPage.rightsList2")}</li>
        <li>{t("privacyPage.rightsList3")}</li>
        <li>{t("privacyPage.rightsList4")}</li>
        <li>{t("privacyPage.rightsList5")}</li>
      </ul>
      <p>{renderTextWithLinks(t("privacyPage.rightsOutro"))}</p>

      <p style={{ textAlign: "center", marginTop: "30px", fontSize: "0.9rem" }}>
        {t("privacyPage.copyright")}
      </p>
    </div>
  );
};

export default PrivacyPolicy;
